/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../../../../shared/theme/colors'
import { spacing } from '../../../../shared/theme/spacing';
import { styles as reportStyles } from '../../ReportsScreen.styles';
import { ticketColors } from '../../../../shared/theme/ticketColors';

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
};

export function ReportsPersonalOperatorSection({
  title,
  subtitle,
  children,
  defaultExpanded = true,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <View style={{ alignSelf: 'stretch', marginTop: spacing.md }}>
      <Pressable
        onPress={() => setExpanded((v) => !v)}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: spacing.sm,
        }}
        accessibilityRole="button"
        accessibilityState={{ expanded }}
        accessibilityLabel={`${title}, ${expanded ? 'contraer' : 'expandir'}`}
      >
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text style={reportStyles.reportsDenseBlockTitle}>{title}</Text>
          {subtitle ? (
            <Text style={[reportStyles.caption, { marginTop: 2 }]} numberOfLines={2}>
              {subtitle}
            </Text>
          ) : null}
        </View>
        <Ionicons
          name={expanded ? 'chevron-up' : 'chevron-down'}
          size={20}
          color={ticketColors.ink2}
        />
      </Pressable>
      {expanded ? <View style={{ marginTop: spacing.sm }}>{children}</View> : null}
    </View>
  );
}

export function PersonalFieldRow({ label, value }: { label: string; value: string }) {
  return (
    <View
      style={[
        reportStyles.reportsDenseListFieldRow,
        { alignSelf: 'stretch', paddingVertical: 7, marginBottom: 2, alignItems: 'center' },
      ]}
    >
      <Text style={[reportStyles.reportsDenseListFieldLabel, { fontSize: 13 }]}>{label}:</Text>
      <Text style={[reportStyles.reportsDenseListFieldValue, { minWidth: 0, fontSize: 13, fontWeight: '600' }]} numberOfLines={8}>
        {value}
      </Text>
    </View>
  );
}
